import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserServicesFactory from '../../user/Services/factory.js'
import {DraftEntitiesFactory} from '../Entities/factory.js'
import {DraftRepositoriesFactory} from '../Repositories/factory.js'

class GenerateCommentAdPublisherUseCase extends UseCase {
  #draftEntityFactory
  #getCurrentUserService
  #repository

  constructor({config}) {
    super()
    this.#draftEntityFactory = DraftEntitiesFactory.draftEntity
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({
      config
    })
    this.#repository = DraftRepositoriesFactory.hTTPDraftRepository({config})
  }

  static create({config}) {
    return new GenerateCommentAdPublisherUseCase({config})
  }

  @tracer({metric: 'GenerateCommentAdPublisherUseCase#execute'})
  @AsyncInlineError()
  async execute({adId}) {
    const userEntity = await this.#getCurrentUserService.execute()
    const userId = userEntity.getId()

    const draftEntityRequest = this.#draftEntityFactory({id: adId, userId})

    const [error, draftEntity] = await this.#repository.generateComment({draftEntity: draftEntityRequest})

    if (error) return Promise.reject(error)

    return draftEntity.toJSON()
  }
}

export const factory = GenerateCommentAdPublisherUseCase.create
